<template>
    <div class="animated fadeIn">
      <div class="row">
        <div class="col-12 pt-3 pb-3 pl-4">
          <h3><i class="fas fa-chart-line"></i> Relatórios - Acompanhamento</h3>
        </div>
      </div>
      <Tables ref="tableGrid"
              :columns="columns"
              :showSearch="true"
              :showReload="false"
              :showTipFooter="false"
              v-on:Search="onShowSearch"
              v-on:Load="onLoadAll"
              v-on:Reload="onLoadAll">
        <template slot="table-header-buttons">
          <a href="javascript:void(0);" v-b-tooltip.hover :title="'Exportar Excel'" @click="onExport">
            <i class="fas fa-file-excel text-third" style="font-size: 15px"></i>
          </a>
        </template>
        <tr v-for="obj in this.objList" v-bind:key="obj.id">
          <template v-if="obj.dataVisita != null">
            <TableColumn :IsDateOnly="true" :status="1" :value="obj.dataVisita" />
            <TableColumn :IsText="true" :status="1" :value="obj.cliente" />
            <TableColumn :IsText="true" :status="1" :value="obj.responsavel" />
            <TableColumn :IsText="true" :status="1" :value="formatTime(obj.tempo)" />
            <TableColumn :IsText="true" :status="1" :value="obj.tipoVisita ? obj.tipoVisita : '-'" />
            <TableColumn :IsText="true" :status="1" :value="obj.statusVisita ? obj.statusVisita : '-'" />
            <TableColumn :IsText="true" :status="1" :value="obj.nomeProduto ? obj.nomeProduto : '-'" />
            <TableColumn :IsText="true" :status="1" :value="obj.valorProduto ? toCurrency(obj.valorProduto) : '-'" />
            <TableColumn :IsText="true" :status="1" :value="obj.observacao ? truncateString(obj.observacao) : '-'" />
          </template>
        </tr>
      </Tables>
      <SidebarSearch @search="onSearch" />
    </div>
  </template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import ReportAcompanhamentoRepository from '@/shared/http/repositories/acompanhamento/report.js'
import SidebarSearch from '@/views/private/visitas/reports/acompanhamento/search/SidebarAcompanhamento.vue'
import moment from 'moment'
import TableColumn from '../../../../../components/forms/TableColumn.vue'

export default {
  name: 'ReportAcompanhamento',
  mixins: [ActionsForm],
  data () {
    return {
      data: null,
      form: null,
      filters: {
        nome: null,
        document: null,
        numeroPA: null,
        nomeRegional: null,
        gerenteId: null,
        responsavelId: null,
        gruposResponsaveisId: null,
        produtosId: null,
        diasAtrasoInicio: null,
        diasAtrasoFinal: null,
        numeroProcesso: null,
        cnj: null,
        assuntoId: null,
        comarcaId: null,
        faseId: null,
        objetoAcaoId: null,
        prognosticoId: null,
        advogadoResponsavel: null,
        advogadoContrario: null,
        dataDistribuicao: null,
        ultimoAndamento: null,
        numProtocolo: null
      },
      columns: [
        'Data da Visita',
        'Cliente',
        'Responsável pela Visita',
        'Tempo da Visita',
        'Tipo de Visita',
        'Status da Visita',
        'Produto/Serviço',
        'Valor do Produto',
        'Observação'
      ]
    }
  },
  components: {TableColumn, SidebarSearch},
  methods: {
    toCurrency (valor) {
      if (!valor || isNaN(+valor)) {
        return null
      }
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(valor)
    },
    onLoad () {
      this.onLoadAll()
    },
    onLoadAll () {
      loading.push()
      console.log(this.filters)
      ReportAcompanhamentoRepository.GetAllAcompanhamento(this.filters, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch(this.onException)
    },
    async onExport () {
      loading.push()

      await ReportAcompanhamentoRepository.GetExcel(this.filters)
        .then((response) => {
          const fileStartName = new Date().toLocaleString('pt-BR').replace(/[^0-9]/g, '')
          const blob = new Blob([this.base64ToArrayBuffer(response.data)], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const url = URL.createObjectURL(blob)

          const a = document.createElement('a')
          a.style.display = 'none'
          a.href = url
          a.download = `${fileStartName}_RelatorioAcompanhamento.xlsx`
          document.body.appendChild(a)
          a.click()
          window.URL.revokeObjectURL(url)
        })
        .catch(this.onException)

      loading.close()
    },
    base64ToArrayBuffer (base64) {
      let binaryString = window.atob(base64)
      var len = binaryString.length
      var bytes = new Uint8Array(len)
      for (var i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i)
      }
      return bytes.buffer
    },
    onSearch (filters) {
      this.filters = filters
      this.$refs.tableGrid.Clear()
      this.$nextTick(() => {
        this.onLoadAll()
      })
    },
    onShowSearch () {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-1')
    },
    formatTime (milliseconds) {
      const duration = moment.duration(milliseconds)
      const days = duration.days()
      const hours = duration.hours()
      const minutes = duration.minutes()
      if (milliseconds < 3600000) { // menos de 1 hora
        return `${minutes} min`
      } else if (milliseconds < 86400000) { // menos de 24 horas
        return `${hours} horas`
      } else {
        return `${days} dias`
      }
    },
    truncateString (str) {
      const maxLength = 30

      // Verifica se a string é maior que o limite
      if (str.length > maxLength) {
        return str.substring(0, maxLength) + '...'
      } else {
        return str
      }
    }
  }
}
</script>
  <style>
  .popover-header {
    background-color: #04a791;
    color: #eceff1
  }
  </style>



// WEBPACK FOOTER //
// src/views/private/visitas/reports/acompanhamento/ReportAcompanhamento.vue